import { IConsultationAttribute } from './types';

// Schema LOCALĂ a atributelor de consultare — oglindește câmpurile de detaliu ale consultării
// (required: title, projectId · optional: description, expiresAt, statusId). BE nu expune un
// endpoint de atribute (`api/surveys/attributes` nu există), deci schema e sursa unică pentru editor.
const FALLBACK_CONSULTATION_ATTRIBUTES: IConsultationAttribute[] = [
	{
		key: 'title',
		label: 'Titlu consultare',
		value: '',
		regex: '^[\\s\\S]{1,200}$',
		dataType: 'text'
	},
	{ key: 'description', label: 'Descriere', value: '', regex: null, dataType: 'text' },
	{
		key: 'projectId',
		label: 'Proiect',
		value: null,
		regex: '^\\d+$',
		dataType: 'number'
	},
	{ key: 'expiresAt', label: 'Expirare', value: null, regex: null, dataType: 'text' },
	{ key: 'statusId', label: 'Status', value: null, regex: null, dataType: 'number' }
];

export { FALLBACK_CONSULTATION_ATTRIBUTES };
